import { useProperties } from 'framework-listing-lib/internal/providers/PropertiesProvider';
export default function usePropertyOverride() {
  const {
    propertyOverride
  } = useProperties();
  return propertyOverride;
}